export function isWideViewport(breakpoint: number = 1920): boolean {
  if (__SERVER__) return false
  return window.innerWidth >= breakpoint
}
